"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dotNotation = require("@cookbook/dot-notation");

var _map = _interopRequireDefault(require("./map"));

var _is = _interopRequireDefault(require("./utils/is"));

var _toArray = _interopRequireDefault(require("./utils/to-array"));

var _typeOf = _interopRequireDefault(require("./utils/type-of"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapper = function mapper(mapping) {
  return function (source) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var result = (0, _toArray.default)(source).map(function (src) {
      if (!_is.default.object(src)) {
        throw new TypeError("Instance of \"source\" must be an object, but instead got \"".concat((0, _typeOf.default)(source), "\""));
      }

      var mapped = _map.default.omitEntries(mapping((0, _map.default)(src, options)));

      if (_is.default.array(mapped)) {
        var values = [];

        if (!mapped.length) {
          return values;
        }

        for (var i = 0; i < mapped.length; i += 1) {
          var value = mapped[i];

          if (value && Object.keys(value).length) {
            values.push((0, _dotNotation.parse)(value));
          }
        }

        return values;
      }

      return Object.keys(mapped).length ? (0, _dotNotation.parse)(mapped) : {};
    });
    return _is.default.array(source) ? result : result[0];
  };
};

var _default = mapper;
exports.default = _default;